module.exports = __webpack_public_path__ + "img/EPF-24D-Goldregen-Studio-9627.9a565a35.jpg";